import { StepType } from '../types/workflows';
import { GENERIC_CODE_TEMPLATE } from './generic-code';
import { GENERIC_API_TEMPLATE } from './generic-api';
import { GENERIC_DATALAKE_QUERY_TEMPLATE } from './data-lake';

export const WORKFLOW_EVENT_TRIGGER_ACTIONS = ['create', 'update', 'delete'];
export const ROLES_PREFIX = 'fnd:workflow';
export const CONSTANTS_PREFIX = 'CONSTANT_';
export const LOG_LEVELS = ['10', '30', '40'];
export const resourceGroup = {
    SYSTEM: 'SYSTEM',
    APP: 'APP'
};
export const SPECIAL_CHARS_REGEX = /[/$*?{}[\]&%]/;

export const defaultCodeTemplateByType: Partial<Record<StepType, string>> = {
    [StepType.GENERIC_CODE]: GENERIC_CODE_TEMPLATE,
    [StepType.GENERIC_API]: GENERIC_API_TEMPLATE,
    [StepType.DATA_LAKE]: GENERIC_DATALAKE_QUERY_TEMPLATE
};
